module.exports = __webpack_public_path__ + "img/nivel_luz.9b371e28.svg";